var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"black-font-color",class:{
    'needs-action': _vm.needsAction,
    'all-good': _vm.doesNotNeedAction
  }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }